:host {
    display: flex;
    flex-direction: column;

    position: relative;

    font-family: var(--body-font-family);
    font-size: 14px;

    
    .type-ahead {
        font-family: inherit;

        position: relative;
        z-index: 2;

        &-wrapper {
            display: flex;
            flex-wrap: nowrap;

            position: relative;

            height: 48px;
            background-color: var(--gray-100);

            font-family: var(--body-font-family);
            font-size: 14px;

            i,
            button {
                display: flex;
                width: 48px;
                justify-content: center;
                align-items: center;
            }

            input,
            button {
                border: none;
                outline: none;
            }

            i {
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
            }

            input {
                padding-left: 15px;
                // background-color: transparent;
                flex-grow: 1;
                font-size: 14px; 
                @media (max-width: 767.99px) {
                    font-size: 16px; // required to prevent auto-zoom
                }

                color: var(--body-color);

                &:focus {
                    box-shadow: var(--gray-300) 0px 0px 0px 4px;
                }
            }

            button {
                background-color: var(--primary);
                color: var(--white);

                cursor: pointer;
                &:hover {
                    opacity: 0.8;
                }

                icon-search {
                    transform: translateY(2px);
                }

                span {
                    visibility: hidden;
                    width: 0;
                    height: 0;
                    position: absolute;
                }
            }
        }
    }

    .type-ahead-suggestions {
        box-sizing: border-box;
        width: 100%;
        position: relative;

        .suggestions,
        .no-results-text,
        .searching-text {
            position: absolute;
            z-index: 1;

            left: 0;
            right: 48px;
            top: 0;

            box-sizing: border-box;
            display: block;
        }

        .suggestions {
            background-color: var(--gray-100);

            box-shadow: 0px 4px 6px rgba(#000, .1);

            max-height: calc(48px * 8);
            overflow: scroll;

            list-style-type: none;
            padding: 0;
            margin: 0;

            border-top: 2px solid var(--gray-300);

            li {
                padding: 0 !important;
            }
        }
        button,
        .no-results-text,
        .searching-text {
            font-size: 14px;
            font-family: var(--body-font-family);

            padding: 1rem;
            border: none;

            display: block;
            width: 100%;

            text-align: left;

            span {
                margin-left: 1rem;
            }

            strong {
                color: var(--primary);
            }

            background-color: var(--gray-100);
        }

        button {
            cursor: pointer;
            &:hover {
                background-color: rgba(var(--primary-rgb), .1);
                color: var(--primary);
            }
        }
    }
}
